module.exports = __webpack_public_path__ + "static/media/ico-phone-hover.d1b50809.svg";